import { PaginatorDesignTokens } from '@primeng/themes/types/paginator';

export default {
    root: {
        padding: '0.5rem 1rem',
        gap: '0.25rem',
        borderRadius: '{content.border.radius}',
        background: '{content.background}',
        color: '#6c757d', // changed by mazars
        transitionDuration: '{transition.duration}'
    },
    navButton: {
        background: 'transparent',
        hoverBackground: '{content.hover.background}',
        selectedBackground: '#E3F2FD', // changed by mazars
        color: '#6c757d', // changed by mazars
        hoverColor: '#6c757d', // changed by mazars
        selectedColor: '#6c757d', // changed by mazars
        width: '2.5rem',
        height: '2.5rem',
        borderRadius: '0%', // changed by mazars
        focusRing: {
            width: '{focus.ring.width}',
            style: '{focus.ring.style}',
            color: '{focus.ring.color}',
            offset: '{focus.ring.offset}',
            shadow: '{focus.ring.shadow}'
        }
    },
    currentPageReport: {
        color: '#6c757d', // changed by mazars
    },
    jumpToPageInput: {
        maxWidth: '2.5rem'
    }
} as PaginatorDesignTokens;